import React, { useEffect, useState } from "react";

export function ReactionToast({ text, show, onDone }) {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (show && text) {
            setVisible(true);
            const t = setTimeout(() => {
                setVisible(false);
                onDone?.();
            }, 2500);
            return () => clearTimeout(t);
        }
        return undefined;
    }, [show, text, onDone]);

    if (!visible || !text) return null;

    return (
        <div
            role="status"
            aria-live="polite"
            data-testid="reaction-toast"
            className="fixed top-6 left-1/2 -translate-x-1/2 z-40 max-w-[min(560px,90vw)] px-5 py-3 rounded-full border border-klareet-T/50 bg-klareet-card/95 backdrop-blur text-klareet-TEXT text-sm shadow-[0_20px_50px_-20px_rgba(13,148,136,0.6)] animate-slide-down"
        >
            <span className="mr-2">✨</span>
            {text}
        </div>
    );
}
